import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from '../util/motion';

gsap.registerPlugin(ScrollTrigger);

// Fades + rises every .reveal element as it scrolls into view.
// Held until `active` so ScrollTrigger measures an unlocked page.
export default function useReveal(active) {
    useEffect(() => {
        if (!active) return;

        const els = gsap.utils.toArray('.reveal');

        if (prefersReducedMotion()) {
            gsap.set(els, { opacity: 1, y: 0 });
            return;
        }

        const tweens = els.map((el) => gsap.fromTo(
            el,
            { opacity: 0, y: 30 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                // Offset in px, not a percentage of the viewport. A percentage
                // start (e.g. "top 88%") is unreachable for the last elements
                // on the page: at maximum scroll the footer only ever gets
                // ~78px above the viewport bottom, so it would never reveal.
                scrollTrigger: { trigger: el, start: 'top bottom-=48px', once: true },
            }
        ));

        ScrollTrigger.refresh();

        return () => {
            tweens.forEach((t) => {
                t.scrollTrigger?.kill();
                t.kill();
            });
        };
    }, [active]);
}
